export const hamburger = () => {
  const hamburger = document.querySelector(".header__hamburger");
  const mobileNav = document.querySelector(".header__mobile-nav");

  if (!hamburger || !mobileNav) return;

  hamburger.addEventListener("click", () => {
    hamburger.classList.toggle("is-active");
    mobileNav.classList.toggle("header__mobile-nav--active");
  });
};